module.exports = __webpack_public_path__ + "img/top-explanation04.c5a4b02e.png";